import React from "react";
import { observer, inject } from "mobx-react";
import { Button, Alert } from "react-bootstrap";
import ErrorParser from "../../ErrorParser";

class ErrorAlert extends React.Component {
  onHandleReload() {
    this.props.reloadHandler();
  }

  onHandleMore() {
    const { stores, error } = this.props;
    stores.ui.modals.showErrorDetail(error);
  }

  onHandleHide() {
    this.props.hideHandler();
  }

  render() {
    const { error, stores } = this.props;

    let alert = null;
    if (error) {
      const parsedError = new ErrorParser(error, stores);

      let viewDetailsButton = null;
      if (parsedError.hasDetail) {
        viewDetailsButton = (
          <Button onClick={this.onHandleMore.bind(this)}>
            {stores.ui.translate.Detail}...
          </Button>
        );
      }

      let reloadButton = null;
      if (parsedError.isConcurrenyError && this.props.reloadHandler) {
        reloadButton = (
          <Button bsStyle="danger" onClick={this.onHandleReload.bind(this)}>
            Reload data
          </Button>
        );
      }

      if (parsedError.message) {
        alert = (
          <Alert bsStyle="danger" onDismiss={this.props.onDismiss}>
            <h4>{parsedError.message}</h4>
            <p>{parsedError.exceptionMessage}</p>
            {reloadButton}
            {viewDetailsButton}
          </Alert>
        );
      }
    }

    return alert;
  }
}

export default inject("stores")(observer(ErrorAlert));



// WEBPACK FOOTER //
// ./src/Core/Components/Alerts/Error.js